import { AbstractRouterFilter, resolveUrl } from '@zk/framework-vue';
import { getToken } from 'common-module/src/util/auth';
import config from 'common-module/src/config';

const PATH = '/create-organization';
export default class CreateOrganizationFilter extends AbstractRouterFilter {
  order() {
    return super.order() + 6;
  }
  getToken () {
    const token = getToken();
    return token || this.option.store.state.user.token;
  }
  async onBefore() {
    const token = this.getToken();
    if (!token){
      return true;
    }
    const userId = this.option.store.getters['user/userId'];
    if (userId === 'temporary0418') {
      window.location.href = resolveUrl(config.VUE_APP_SSO_URL + PATH);
      return false;
    }
    return true;
  }
}
